const CalendarType = {
    AGENT: 'agent',
    ASSET: 'asset',
};

export default CalendarType;
